import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
	selector: 'app-payment-success-dialog',
	standalone: true,
	imports: [],
	templateUrl: './payment-success-dialog.component.html',
	styleUrls: ['../payment-dialog-box/payment-dialog-box.component.scss'],

})
export class PaymentSuccessDialogComponent {

	finalAmount :number = 0;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { amount: number },
		private dialogRef: MatDialogRef<PaymentSuccessDialogComponent>,
		private router:Router
	) { 
		this.finalAmount = data.amount;
	}

	close() {
		this.dialogRef.close(true);
	}

	goToHome(){
		this.router.navigate(['/student-dashboard/home']);
		this.close();
	}
}
